import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import Avatar from 'react-avatar';

import { BaseComponent } from '../../Component';
import theme from '../../../theme/theme';

export interface HeaderMenuComponent extends BaseComponent {
  type: 'menu';
  props: HeaderMenuProps;
}

export interface HeaderMenuProps {
  menuItems?: JSX.Element[];
  handleLoginLogout: Function;
  loginLogoutLabel: string;
  avatarName?: string;
  avatarEmail?: string;
  avatarSrc?: string;
}

export const HeaderMenu: React.FC<HeaderMenuProps> = ({
  menuItems,
  handleLoginLogout,
  loginLogoutLabel,
  avatarName,
  avatarEmail,
  avatarSrc,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLoginLogoutClick = () => {
    handleLoginLogout();
    handleClose();
  };

  return (
    <div data-tut="reactour__avatar">
      <IconButton
        aria-controls="appHeader-menu"
        aria-haspopup="true"
        onClick={handleClick}
        data-testid="header-menu-button"
        size="large"
      >
        <Avatar
          name={avatarName}
          email={avatarEmail}
          src={avatarSrc}
          size="50px"
          round={true}
          color="#AAAAAA"
        />
      </IconButton>
      <Menu
        id="appHeader-menu"
        anchorEl={anchorEl}
        disableEnforceFocus={true}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems &&
          menuItems.map((menuItem, index) => {
            return (
              <div key={index}>
                <MenuItem>{menuItem}</MenuItem>
              </div>
            );
          })}
        <div>
          <MenuItem
            sx={{ marginRight: theme.spacing(2) }}
            onClick={() => {
              handleLoginLogoutClick();
            }}
          >
            <Typography variant="body2">{loginLogoutLabel}</Typography>
          </MenuItem>
        </div>
      </Menu>
    </div>
  );
};
